<script>
  import acessosServico from '../servico';
    
  import "~componentes/../js/inspinia";

  import AcessoTipos from './compartilhado/AcessoTipos.vue';
  import AppFooter from '~componentes/Footer.vue';
  import VoltarAoTopo from '~componentes/VoltarAoTopo.vue';

  export default {
    components: { AppFooter, VoltarAoTopo, AcessoTipos },
    data() {
      return {
        acessoTipos: [],
        carregando: true,
        filtros: this.camposFiltros(),
        configuracao: this.$storage.configuracao(),

        tipo: '',
        classImagem: '',
        mensagemNenhumItem: '',
      }
    },
    methods: {
      camposFiltros() {
        return {
          idProjeto: '',
          idUnidade: '',
          idSolicitacaoCursosEventosServicos: '',
          pagina: 1,
          registrosPagina: 10000,
        };
      },
      lista() {
        this.carregando = true;

        return acessosServico.listaAcessoItens(this.filtros, this.$route.name)
          .then(res => {
            this.carregando = false;

            this.acessoTipos = res.body.registros;
          });
      },
      configuraTipo() {
        switch (this.$route.name) {
          case 'acessos.cursos':
            this.tipo = 'CURSOS';
            this.classImagem = 'bannerRosto_interno_curso';
            this.mensagemNenhumItem = 'Nenhum curso encontrado!'
            break;
          case 'acessos.eventos':
            this.tipo = 'EVENTOS'; 
            this.classImagem = 'bannerRosto_interno_evento';
            this.mensagemNenhumItem = 'Nenhum evento encontrado!'
            break;
          case 'acessos.servicos':
            this.tipo = 'SERVIÇOS'; 
            this.classImagem = 'bannerRosto_interno_servico';
            this.mensagemNenhumItem = 'Nenhum serviço encontrado!'
            break;
          case 'acessos.doacoes':
            this.tipo = 'DOAÇÕES';
            this.classImagem = 'bannerRosto_interno_doacao';
            this.mensagemNenhumItem = 'Nenhuma doação encontrada!'
            break;
          case 'acessos.licitacoes':
            this.tipo = 'LICITAÇÕES';
            this.classImagem = 'bannerRosto_interno_licitacao';
            this.mensagemNenhumItem = 'Nenhuma licitação encontrada!'
            break;
          default:
            this.$router.push('/acessos');
        }
      },
    },
    computed: {
      possuiItens() {
        return this.acessoTipos.length > 0;
      },
    },
    created() {
      this.configuraTipo();

      this.lista();
    },
  }
</script>

<template>
  <div>
    <section id="sectionBanner"
             :class="'bannerRosto_interno ' + classImagem">

      <div id="texto-img" class="text-center">
        <h1 class="text-center">
          <strong>
            <span id="lblTipo">{{ tipo }}</span>
          </strong>
        </h1>
      </div>

    </section>

    <div class="container" style="padding-top:320px;">      
      <div class="middle-box text-center" v-show="!possuiItens">
        <h2 class="font-bold" style="color: #337ab7;">{{ mensagemNenhumItem }}</h2> 
      </div>

      <acesso-tipos :acessoTipos="acessoTipos" v-show="!carregando && possuiItens">
      
      </acesso-tipos>
    </div>
  </div>
</template>

<style scoped>
  @media (max-width: 100px) {
    .bannerRosto_interno {
        background-position-y: 0px;
    }
  }

  .bannerRosto_interno_curso {
    background: url('/img/acesso/banners/cursos.jpg');
  }

  .bannerRosto_interno_evento {
    background: url('/img/acesso/banners/eventos.jpg');
  }

  .bannerRosto_interno_servico {
    background: url('/img/acesso/banners/servicos.jpg');
  }

  .bannerRosto_interno_doacao {
    background: url('/img/acesso/banners/doacoes.jpg');
  }

  .bannerRosto_interno_licitacao {
    background: url('/img/acesso/banners/licitacoes.jpg');
  }
  
  .bannerRosto_interno {    
    background-repeat: no-repeat;
    background-position: right -80px;
    overflow: hidden;
    background-size: cover;
    height: 50vh;
    animation-name: img-ani;
    animation-duration: 1s;
    animation-timing-function: ease-in;
    left: 0px;
    width: 100%;
    height: 300px;
    position: absolute;
  }

  .text-center {
    color:white;
    justify-content: center;
    padding-top: 40px;
    font-size: 35px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/AcessosListagem.vue